import React from 'react';

// styles
import {
  HeroWrapper,
  HeroContainer,
  StyledTitle,
  StyledDescription,
} from './Hero.styles';

export function Hero({ content }) {
  return (
    <HeroWrapper>
      <HeroContainer>
        <StyledTitle>
          {content.title}
          <br /> {content.titleLine2}
        </StyledTitle>
        <StyledDescription>{content.description}</StyledDescription>
      </HeroContainer>
    </HeroWrapper>
  );
}
